import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryShareIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19.15 14.55C17.46 14.55 16 15.47 15.2 16.83L9.23 13.35C9.36 12.92 9.46 12.47 9.46 12C9.46 11.53 9.37 11.08 9.23 10.65L15.2 7.17C16 8.53 17.46 9.45 19.15 9.45C21.69 9.45 23.75 7.39 23.75 4.85C23.75 2.31 21.69 0.25 19.15 0.25C16.61 0.25 14.55 2.31 14.55 4.85C14.55 5.25 14.62 5.63 14.71 6L8.7 9.5C7.88 8.24 6.46 7.39 4.85 7.39C2.31 7.4 0.25 9.46 0.25 12C0.25 14.54 2.31 16.6 4.85 16.6C6.47 16.6 7.88 15.76 8.7 14.49L14.71 17.99C14.61 18.36 14.55 18.74 14.55 19.14C14.55 21.68 16.61 23.74 19.15 23.74C21.69 23.74 23.75 21.68 23.75 19.14C23.75 16.6 21.69 14.54 19.15 14.54V14.55ZM19.15 1.75C20.86 1.75 22.25 3.14 22.25 4.85C22.25 6.56 20.86 7.95 19.15 7.95C17.44 7.95 16.05 6.56 16.05 4.85C16.05 3.14 17.44 1.75 19.15 1.75ZM4.85 15.1C3.14 15.1 1.75 13.71 1.75 12C1.75 10.29 3.14 8.9 4.85 8.9C6.56 8.9 7.95 10.29 7.95 12C7.95 13.71 6.56 15.1 4.85 15.1ZM19.15 22.25C17.44 22.25 16.05 20.86 16.05 19.15C16.05 17.44 17.44 16.05 19.15 16.05C20.86 16.05 22.25 17.44 22.25 19.15C22.25 20.86 20.86 22.25 19.15 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryShareIcon.displayName = 'LibraryShareIcon';
